import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import * as rostersActions from 'features/rosters/duck';
import { RostersAssignBar } from 'features/rosters';
import {
  Input,
  ModalInfo,
  MultiRadio,
  AlertNotice,
  AlertMessage,
  SimpleModal,
} from 'shared/components';
import { groupBy, isNull, isUndefined } from 'lodash';
import { WKYS_EXAMINEE_TYPES } from 'shared/constants';
import { getRoomTimingName } from 'shared/helpers';

import './RostersAssign.scss';

const transform = (listOfOptions, unassignDisabled, mappedRoomTiming, t, programCode) => {
  const newList = [];

  newList.push({
    customLabel: setLabel({}, true, !unassignDisabled, t),
    key: 'room',
    value: -1,
    name: 'roomUnassign',
    disabled: unassignDisabled,
  });
  listOfOptions.forEach((option) => {
    newList.push({
      customLabel: setLabel(option, false, false, t),
      key: 'room' + option.id,
      value: option.id,
      name: 'room' + option.id,
      disabled: !option.compatibleRoom,
      childElement:
        `<div class="font-size-12 label-container">` +
        `<span class="tag">${
          option.type ? option.type : t('testCenter.roomDashboard.noTypeLabel')
        }</span> ${
          option.timing ? `<span class="tag">${getRoomTimingName(option.timing, programCode, mappedRoomTiming)}</span>` : ''
        }` +
        `${
          option.singleRoomFlag
            ? `<span class="tag">${t('roomBuilder.singleRoom.infoValue')}</span>`
            : ''
        }` +
        `<span class="tag">${
          option.onlineFlag ? t('common.labels.online') : t('common.labels.paper')
        }</span>` +
        `</div>`,
    });
  });
  return newList;
};

const setLabel = (option, unassign, unassignEnabled, t) => {
  if (option.compatibleRoom || unassignEnabled) {
    return (
      <label>
        {unassign
          ? t('common.labels.unAssign')
          : `${option.name}(${option.assigned}/${option.capacity})`}
      </label>
    );
  } else {
    return (
      <label
        tabIndex="0"
        className="roster-tooltip"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        data-bs-trigger="focus"
        data-bs-title={t(
          `rosters.assignExamineesModal.${unassign ? 'unassignTooltip' : 'disabledRoomTooltip'}`
        )}>
        {unassign
          ? t('common.labels.unAssign')
          : `${option.name}(${option.assigned}/${option.capacity})`}
      </label>
    );
  }
};

const getTotalExamByType = (list) => {
  const groupedElements = groupBy(list, 'regType');
  let stringList = '';

  Object.keys(groupedElements).forEach(
    (key) =>
      (stringList = stringList.concat(
        `${stringList.length ? ', ' : ''}${groupedElements[key].length} ${key}`
      ))
  );

  return stringList;
};

class RostersAssign extends Component {
  constructor(props) {
    super(props);

    this.state = {
      assignModalOpen: false,
      enableRooms: false,
      selectedRoomId: null,
      assignedUsersList: [],
      roomsList: [],
      successNotificationVisible: false,
      warningUnassignOpen: false,
      saveButtonDisabled: false,
      isNCRCAssignment: false,
    };

    this.closeAssignModal = this.closeAssignModal.bind(this);
    this.openAssignModal = this.openAssignModal.bind(this);
    this.toggleEnableRooms = this.toggleEnableRooms.bind(this);
    this.onSelectOption = this.onSelectOption.bind(this);
    this.onSubmitExaminees = this.onSubmitExaminees.bind(this);
    this.removeSuccessNotification = this.removeSuccessNotification.bind(this);
    this.fetchAfterAssign = this.fetchAfterAssign.bind(this);
    this.closeWarningModal = this.closeWarningModal.bind(this);
  }

  componentDidUpdate() {
    Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach((el) =>
      bootstrap.Tooltip.getOrCreateInstance(el).enable()
    );
  }

  openAssignModal() {
    const { listOfSelectedExaminees, selectedLocation, actions } = this.props;
    const assignedUsersList = listOfSelectedExaminees.filter(
      (ex) => !isNull(ex.roomName) && !isUndefined(ex.roomName)
    );

    const isNCRCAssignment = listOfSelectedExaminees.every((i) =>
      i.regType?.toLowerCase().includes(WKYS_EXAMINEE_TYPES.ncrc.toLowerCase())
    );

    Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach((el) =>
      bootstrap.Tooltip.getOrCreateInstance(el).enable()
    );

    const apiParams = isNCRCAssignment ? { ncrcFlag: true } : undefined;

    actions
      .getCompatibleRooms(
        selectedLocation.locationEvent.id,
        listOfSelectedExaminees.map((ex) => ex.id),
        apiParams
      )
      .then(() => {
        this.setState(() => ({
          assignModalOpen: true,
          roomsList: transform(
            this.props.compatibleRooms,
            !assignedUsersList.length,
            this.props.mappedRoomTiming,
            this.props.t,
            this.props.tcEvent?.testingEvent?.adminId?.cycleId?.programId?.code
          ),
          enableRooms: false,
          selectedRoomId: null,
          assignedUsersList,
          isNCRCAssignment,
        }));
      });
  }

  closeAssignModal() {
    this.setState({
      assignModalOpen: false,
      enableRooms: false,
      selectedRoomId: null,
      error: '',
      saveButtonDisabled: false,
      isNCRCAssignment: false,
    });
  }

  toggleEnableRooms() {
    const { selectedLocation, listOfSelectedExaminees } = this.props;
    const { enableRooms, isNCRCAssignment } = this.state;

    this.setState((prevState) => ({
      enableRooms: !prevState.enableRooms,
      selectedRoomId: null,
    }));

    const apiParams = { enableRooms: !enableRooms };
    if (isNCRCAssignment) {
      apiParams.ncrcFlag = true;
    }

    this.props.actions
      .getCompatibleRooms(
        selectedLocation.locationEvent.id,
        listOfSelectedExaminees.map((ex) => ex.id),
        apiParams
      )
      .then(() => {
        this.setState(() => ({
          roomsList: transform(
            this.props.compatibleRooms,
            !listOfSelectedExaminees.filter(
              (ex) => !isNull(ex.roomName) && !isUndefined(ex.roomName)
            ).length,
            this.props.mappedRoomTiming,
            this.props.t,
            this.props.tcEvent?.testingEvent?.adminId?.cycleId?.programId?.code
          ),
          // selectedRoomId: isSelectedCompatible(prevState.selectedRoomId, this.props.compatibleRooms),
        }));
      });
  }

  onSelectOption(e) {
    const { value } = e.target;

    this.setState({
      selectedRoomId: +value,
    });
  }

  fetchAfterAssign() {
    const { actions, selectedLocation } = this.props;

    this.props.onReloadExaminees();
    this.props.onDeselectAllExaminees();
    actions.getLocationEventExamineeCount(selectedLocation.locationEvent.id);

    this.setState({
      successNotificationVisible: true,
    });
  }

  onSubmitExaminees(submitAssignedExamFlag) {
    this.setState({
      saveButtonDisabled: true,
    });
    const { selectedRoomId } = this.state;
    const { actions, listOfSelectedExaminees, selectedLocation } = this.props;

    if (!selectedRoomId) {
      this.setState({
        error: this.props.t('rosters.assignExamineesModal.errorSelectionRequired'),
        saveButtonDisabled: false,
      });
      return;
    }
    const assignedExaminees = listOfSelectedExaminees.filter(
      (ex) => !isNull(ex.roomName) && !isUndefined(ex.roomName)
    );

    if (assignedExaminees.length && !submitAssignedExamFlag) {
      this.setState({
        warningUnassignOpen: true,
        saveButtonDisabled: false,
      });
      return;
    }

    if (selectedRoomId > 0) {
      actions
        .assignExamineesToRoom(
          selectedRoomId,
          listOfSelectedExaminees.map((ex) => ex.id)
        )
        .then(() => {
          if (this.props.errorAssign) {
            this.closeWarningModal();
            this.setState({
              error: this.props.t('rosters.assignExamineesModal.errorAssign'),
            });
          } else {
            this.fetchAfterAssign();
            this.closeWarningModal();
            this.closeAssignModal();
          }
        })
        .finally(() => {
          this.setState({ saveButtonDisabled: false });
        });
    } else {
      actions
        .unassignExaminees(selectedLocation.locationEvent.id, {
          absent: false,
          deniedReason: null,
          deniedReasonDetails: null,
          regIds: [...assignedExaminees.map((ex) => ex.id)],
        })
        .then(() => {
          if (this.props.errorUnassign) {
            this.closeWarningModal();
            this.setState({
              error: this.props.t('rosters.assignExamineesModal.errorAssign'),
            });
          } else {
            this.fetchAfterAssign();
            this.closeWarningModal();
            this.closeAssignModal();
          }
        });
    }
  }

  removeSuccessNotification() {
    this.setState({
      successNotificationVisible: false,
    });
  }

  closeWarningModal() {
    this.setState({
      warningUnassignOpen: false,
    });
  }

  render() {
    const {
      listOfSelectedExaminees,
      selectedLocation,
      compatibleRooms,
      loadingCompatibleRooms,
      onSelectAll,
      openAbsentModal,
      openDeniedModal,
      testCenterCycle,
    } = this.props;

    const {
      assignModalOpen,
      enableRooms,
      roomsList,
      selectedRoomId,
      error,
      successNotificationVisible,
      warningUnassignOpen,
      isNCRCAssignment,
    } = this.state;

    return (
      <React.Fragment>
        <RostersAssignBar
          onDeselectAllExaminees={this.props.onDeselectAllExaminees}
          listOfSelectedExaminees={listOfSelectedExaminees}
          goBack={this.props.goBack}
          onAssignExaminees={this.openAssignModal}
          onSelectAll={onSelectAll}
          openAbsentModal={openAbsentModal}
          openDeniedModal={openDeniedModal}
        />
        <ModalInfo
          modalIsOpen={assignModalOpen}
          closeModal={this.closeAssignModal}
          onSubmit={() => this.onSubmitExaminees(false)}
          className="rosters-assign-modal"
          headerTitle={this.props.t('rosters.assignExamineesModal.title')}
          saveLabel={this.props.t('common.labels.save')}
          disabledSubmit={this.state.saveButtonDisabled}>
          <div className="border-bottom-gray mb-3">
            {!loadingCompatibleRooms && !compatibleRooms.some((r) => r.compatibleRoom) && (
              <AlertNotice
                message={this.props.t('rosters.assignExamineesModal.allRoomsDisabledMessage')}
              />
            )}

            <h5 className="dark-gray">
              {this.props.t('rosters.assignExamineesModal.selectedExaminees', {
                totalSelected: listOfSelectedExaminees.length,
              })}{' '}
              ({getTotalExamByType(listOfSelectedExaminees)})
            </h5>
            <p className="font-size-12 dark-gray">
              {selectedLocation.name}
              {selectedLocation.area &&
                selectedLocation.area.length > 0 &&
                `, ${selectedLocation.area}`}
            </p>
            {!isNCRCAssignment && (
              <>
                <Input
                  containerClassName=""
                  type="checkbox"
                  name="enableRooms"
                  id="enableRooms"
                  checked={enableRooms}
                  onChange={this.toggleEnableRooms}>
                  <label htmlFor="enableRooms">
                    {this.props.t('rosters.assignExamineesModal.enableRoomsLabel')}
                  </label>
                </Input>
                <p className="font-size-12 dark-gray description">
                  {this.props.t('rosters.assignExamineesModal.infoMessage')}
                </p>
                {enableRooms && (
                  <AlertNotice
                    message={this.props.t('rosters.assignExamineesModal.enabledRoomsInfoMessage')}
                  />
                )}
              </>
            )}
          </div>
          {error && <p className="text-error">{error}</p>}
          <MultiRadio
            onChange={this.onSelectOption}
            radioList={roomsList}
            checkedValue={selectedRoomId}
          />
        </ModalInfo>
        <SimpleModal
          isOpen={warningUnassignOpen}
          onCancel={this.closeWarningModal}
          onConfirm={() => this.onSubmitExaminees(true)}
          headline={this.props.t(
            testCenterCycle?.testCenterProgram?.program.parentCode === 'workkeys'
              ? 'rosters.unassignWarningMessageWK'
              : 'rosters.unassignWarningMessage'
          )}
          confirmLabel={this.props.t('common.labels.continue')}
          cancelLabel={this.props.t('common.labels.cancel')}
        />
        <AlertMessage
          show={successNotificationVisible}
          removeMessage={this.removeSuccessNotification}
          message={this.props.t('rosters.assignSuccessMessage')}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    compatibleRooms: state.rosters.compatibleRooms,
    errorAssign: state.rosters.errorAssign,
    errorUnassign: state.rosters.errorUnassign,
    loadingCompatibleRooms: state.rosters.loadingCompatibleRooms,
    mappedRoomTiming: state.statics.mappedRoomTiming,
    testCenterCycle: state.tcEvent.testCenterCycle || {},
    tcEvent: state.tcEvent.currentEvent,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...rostersActions,
      },
      dispatch
    ),
  };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RostersAssign));

RostersAssign.propTypes = {
  t: PropTypes.func.isRequired,
  compatibleRooms: PropTypes.array,
  errorAssign: PropTypes.bool,
  errorUnassign: PropTypes.bool,
  loadingCompatibleRooms: PropTypes.bool,
  mappedRoomTiming: PropTypes.object,
  actions: PropTypes.shape({
    getCompatibleRooms: PropTypes.func,
    assignExaminees: PropTypes.func,
    unassignExaminee: PropTypes.func,
  }),
  examinees: PropTypes.array,
  tceId: PropTypes.number,
  roomTimingId: PropTypes.number,
  onRefresh: PropTypes.func,
  closeModal: PropTypes.func,
  isOpen: PropTypes.bool,
};

RostersAssign.propTypes = {
  // Props from parent component
  listOfSelectedExaminees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      roomName: PropTypes.string,
      regType: PropTypes.string,
    })
  ).isRequired,
  selectedLocation: PropTypes.shape({
    locationEvent: PropTypes.shape({
      id: PropTypes.number,
    }),
    name: PropTypes.string,
    area: PropTypes.string,
  }).isRequired,
  onReloadExaminees: PropTypes.func.isRequired,
  onDeselectAllExaminees: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  openAbsentModal: PropTypes.func.isRequired,
  openDeniedModal: PropTypes.func.isRequired,

  // Props from mapStateToProps
  compatibleRooms: PropTypes.arrayOf(
    PropTypes.shape({
      compatibleRoom: PropTypes.bool,
    })
  ).isRequired,
  errorAssign: PropTypes.bool,
  errorUnassign: PropTypes.bool,
  loadingCompatibleRooms: PropTypes.bool,
  mappedRoomTiming: PropTypes.object,
  testCenterCycle: PropTypes.shape({
    testCenterProgram: PropTypes.shape({
      program: PropTypes.shape({
        parentCode: PropTypes.string,
      }),
    }),
  }),

  // Props from mapDispatchToProps
  actions: PropTypes.shape({
    getCompatibleRooms: PropTypes.func.isRequired,
    assignExamineesToRoom: PropTypes.func.isRequired,
    unassignExaminees: PropTypes.func.isRequired,
    getLocationEventExamineeCount: PropTypes.func.isRequired,
  }).isRequired,
};
